import React, { Component } from 'react';
import { FONT_SIZES, NEUTRAL } from './Theme';

const styles = {
  container: {
    padding: '20px',
    textAlign: 'center',
    color: NEUTRAL.textSecondary,
  },
  button: {
    padding: '10px 20px',
    marginTop: '15px',
    fontSize: FONT_SIZES.body,
    cursor: 'pointer',
  },
};

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
    this.handleReset = this.handleReset.bind(this);
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    console.error('ErrorBoundary caught an error', error, errorInfo);
  }

  handleReset() {
    this.setState({ hasError: false, error: null, errorInfo: null });
  }

  render() {
    const { hasError, error, errorInfo } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <div style={styles.container}>
          <h1>Something went wrong.</h1>
          <p>We are sorry for the inconvenience.</p>
          <button type="button" onClick={this.handleReset} style={styles.button}>
            Try Again
          </button>
          {error && (
            <details style={{ whiteSpace: 'pre-wrap', marginTop: '10px' }}>
              <summary>Click for error details</summary>
              {error.toString()}
              <br />
              {errorInfo.componentStack}
            </details>
          )}
        </div>
      );
    }
    return children;
  }
}

export default ErrorBoundary;
